module.exports = __webpack_public_path__ + "media/images/application/template/logo-leviat-no-crh-centrered-4fc8fb783fa988f3e41c810638c1e893.svg";